module.exports = __webpack_public_path__ + "static/media/singaporeRound.fb67137a.svg";